import { Yup } from '@frontman/utils';

export const userInformationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('First name is required')
    .min(2, 'First name must be at least 2 characters long')
    .max(50, 'First name can be at most 50 characters long')
    .matches(/^[a-zA-Z\s-']+$/, 'Invalid characters in first name')
    .trim(),
  lastName: Yup.string()
    .required('Last Name is required')
    .min(2, 'Last Name must be at least 2 characters long')
    .max(50, 'Last Name can be at most 50 characters long')
    .matches(/^[a-zA-Z\s-']+$/, 'Invalid characters in Last Name')
    .trim(),
  email: Yup.string()
    .required('Please enter your email.')
    .emailValidator('Please enter a valid email.'),
});
